module.exports = __webpack_public_path__ + "img/step1.c97e824a.svg";